<template>
<div>
    <form ref="form" v-kendo-validator="setup()" @submit.prevent="addForm()">
        <div class="page-header d-flex w-100">
            <div class="title-col d-flex w-50">
                <span class="title-icon">
                    <b-icon-folder-fill></b-icon-folder-fill>
                </span>
                <span class="title-text">{{ add ? 'Add Feature' : 'Update Feature'}} </span>

            </div>
            <div class="text-right ml-auto">
                <button class="k-button k-green ml-2"> {{ add ? 'Add' : 'Update'}}</button>
                <button class="k-button k-gray ml-2" @click="goToListPage">Cancel</button>
            </div>
        </div>
        <div class="page-body">
            <div class="bg-white p-4">

                <div class="row">
                    <div class="col-3 form-group">
                        <label>Name<span style="color: red;">*</span></label>
                        <k-input
                        class="w-100 rounded-border"
                            v-model="name" type="text" :name="'Name'" :required="true"></k-input>
                    </div>
                    <div class="col-3 form-group">
                         <label>Type<span style="color: red;">*</span></label>
                                <dropdownlist :data-items="type" v-model="data.type" :text-field="'name'"
                                    :data-item-key="'id'" :required="true" :name="'type'" class="w-100" :value="typeData" @change="changeType"></dropdownlist>
                        <span data-for='type' class='k-invalid-msg'></span>
                    </div>                   
                </div>
            </div>
        </div>
    </form>
</div>    
</template>
<script>
import { MESSAGES } from "@/utils/constants";
import { notifyWarn, notifyApiError } from "@/utils/notification-helper";

export default {
  data: function() {
    return {
      data: {},
      search: "",
      name: null,
      typeData: null,
      type: [
        { name: "General", id: 1 },
        { name: "Addon", id: 2 }
      ],
      add: this.$route.params.add,
    };
  },
  methods: {
    goToListPage(){
        this.$router.push({name: 'Feature'})
    },
    async addForm() {
      if (this.name && this.data.type) {
        let dataVal = {
          name: this.name,
          type: this.data.type.name
        };
        if (this.add) {
          await this.$store.dispatch("featureConfig/addFeature", dataVal).then(() => {
            this.goToListPage();
          }).catch(e => notifyApiError(e));
        } else {
          dataVal.id = this.data.id;
          await this.$store
            .dispatch("featureConfig/updateFeature", dataVal)
              this.goToListPage();
        }
      }
      else{
        notifyWarn(MESSAGES.FILL_REQUIRED_FIELDS)
      }
    },
    changeType(e) {
        this.typeData = e.value
    },
    setup: function() {
      return {
        rules: {
          getType(input) {
            if (input.is("[name='type'") && input.val() == "") {
              return false;
            }
            return true;
          },
        },
        messages: {
          getType: "Type is required",
        },
      }
    }
  },
  computed: {
  },
  beforeMount() {
    if (!this.$route.params.add) {
      let featureData = this.$store.getters["featureConfig/editFeature"];
      this.data.id = featureData.id
      this.name = featureData.name;
      this.data.type = this.type.find(obj => obj.name == featureData.type);
    }
  }
};
</script>

